import { gql } from '@apollo/client';
const GET_COMPONENT_SELECTOR_PRODUCT_FILTERS = gql `
  query GetComponentSelectorProductFilters($first: Int = 500) {
    autocomplete {
      id
      productFunctions(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
      productSustainabilities(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
      productCertificates(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
      productContinents(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
      productCountries(first: $first) {
        edges {
          node {
            id
            name
            continent {
              id
            }
          }
        }
      }
      productEvents(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
      productMainCategories(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
export default GET_COMPONENT_SELECTOR_PRODUCT_FILTERS;
